import {Injectable} from '@angular/core';
import {AnimationController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AnimationsManagerService {

  constructor(
    private animationCtrl: AnimationController
  ) {
  }

  /**
   * Animación para mostrar el modal
   *
   */
  public showModalAnimation = (baseEl: HTMLElement) => {
    const root = baseEl.shadowRoot;

    const backdropAnimation = this.animationCtrl
      .create()
      .addElement(root?.querySelector('ion-backdrop')!)
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

    const wrapperAnimation = this.animationCtrl
      .create()
      .addElement(root?.querySelector('.modal-wrapper')!)
      .keyframes([
        {offset: 0, opacity: '0', transform: 'translateY(20px)'},
        {offset: 1, opacity: '1', transform: 'translateY(0)'},
      ]);

    return this.animationCtrl
      .create()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(200)
      .addAnimation([backdropAnimation, wrapperAnimation]);
  };


  /**
   * Animación para ocultar el modal
   *
   */
  public hideModalAnimation = (baseEl: HTMLElement) => {
    return this.showModalAnimation(baseEl).direction('reverse');
  };


  /**
   * Animación para mostrar la alerta
   *
   */
  public showAlertAnimation = (baseEl: HTMLElement) => {

    const backdropAnimation = this.animationCtrl
      .create()
      .addElement(baseEl.querySelector('ion-backdrop')!)
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

    const wrapperAnimation = this.animationCtrl
      .create()
      .addElement(baseEl.querySelector('.alert-wrapper')!)
      .fromTo('transform', 'translateY(100%)', 'translateY(0)')
      .fromTo('opacity', '0.8', '1');

    return this.animationCtrl
      .create()
      .duration(200)
      .easing('ease-out')
      .addAnimation([backdropAnimation, wrapperAnimation]);
  }


  /**
   * Animación para ocultar la alerta
   *
   */
  public hideAlertAnimation = (baseEl: HTMLElement) => {
    return this.showAlertAnimation(baseEl).direction('reverse');
  }

}
